'use client';

import { createContext, useContext, ReactNode } from 'react';

import { RouterAdapter } from '../types';

const RouterContext = createContext<RouterAdapter | null>(null);

export const RouterProvider = ({ children, router }: { children: ReactNode; router: RouterAdapter }) => {
  return <RouterContext.Provider value={router}>{children}</RouterContext.Provider>;
};

export const useCommonRouter = (): RouterAdapter => {
  const router = useContext(RouterContext);
  if (!router) {
    throw new Error('useCommonRouter must be used within RouterProvider');
  }
  return router;
};
